(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vgravity", [], factory);
	else if(typeof exports === 'object')
		exports["vgravity"] = factory();
	else
		root["vgravity"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
  design by zhangyingying at 2018-02-28
  重力感应 el元素需要定位 消耗性能，建议页面使用效果不超过5个
  参数 x, y => x, y轴的相对位移 d=> 位移方向
  使用 v-gravity="{x: 20, y: 20, d: 1}"
**/
/* harmony default export */ __webpack_exports__["default"] = (function (Vue) {
  Vue.directive('gravity', {
    bind: function bind(el, binding, vNode) {
      var objM = binding.modifiers;
      var objV = binding.value;
      var objA = binding.arg;
      var conf = {
        gx: 0,
        gy: 0
      };
      var direction = 1;
      if (!!objV.x) {
        conf.gx = objV.x;
      }
      if (!!objV.y) {
        conf.gy = objV.y;
      }
      if (!!objV.d) {
        direction = objV.d;
      }
      var target = el;
      function handleOrientation(event) {
        var x = event.beta; //  [-180, 180]
        var y = event.gamma; //  [-90, 90]
        if (x > 90) {
          x = 90;
        };
        if (x < -90) {
          x = -90;
        };
        if (x > 80 && x < 150) {
          // 粘度系数0.2
          // 当beta>80时，gamma转动速度变大，并且当gamma大于80时容易正负突变
          y = Math.abs(y) * 0.2;
        }
        x += 90;
        y += 90;
        if (!!objM.rotateX) {
          target.style['-webkit-transform-style'] = 'preserve-3d';
          target.style['transform-style'] = 'preserve-3d';
          target.style['-webkit-transform'] = 'rotateX(' + x * conf.gx + 'deg)';
          target.style['transform'] = 'rotateX(' + x * conf.gx + 'deg)';
        } else if (!!objM.rotateY) {
          target.style['-webkit-transform-style'] = 'preserve-3d';
          target.style['transform-style'] = 'preserve-3d';
          target.style['-webkit-transform'] = 'rotateY(' + y * conf.gy + 'deg)';
          target.style['transform'] = 'rotateY(' + y * conf.gy + 'deg)';
        } else if (!!objM.rotate) {
          target.style['-webkit-transform-style'] = 'preserve-3d';
          target.style['transform-style'] = 'preserve-3d';
          target.style['-webkit-transform'] = 'rotateX(' + x * conf.gy + 'deg rotateY(' + y * conf.gy + 'deg)';
          target.style['transform'] = 'rotateX(' + x * conf.gy + 'deg) rotateY(' + y * conf.gy + 'deg)';
        } else {
          target.style.top = direction * (conf.gy * x / 180 - conf.gy / 2) + "px";
          target.style.left = direction * (conf.gx * y / 180 - conf.gx / 2) + "px";
        }
      }
      window.addEventListener('deviceorientation', handleOrientation);
    }
  });
});

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// vgravity.js